module.exports = __webpack_public_path__ + "img/work1.017e13f7.gif";